import { FieldError, SelectBlock } from "../style";

// Нативный select в стиле InputComponent (подпись внутри рамки, ошибка под полем).
const SupportSelectField = ({ label, value, onChange, options, placeholder, required, error, touched, disabled }) => (
  <div style={{ width: "100%" }}>
    <SelectBlock $isError={touched && error}>
      {label && (
        <label>
          {label} {required && <span>*</span>}
        </label>
      )}
      <select value={value} onChange={e => onChange(e.target.value)} disabled={disabled}>
        {placeholder !== undefined && (
          <option value="" disabled={required}>
            {placeholder}
          </option>
        )}
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </SelectBlock>
    {touched && error && <FieldError>{error}</FieldError>}
  </div>
);

export default SupportSelectField;
